var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"mt-3"},[_c('b-row',[_c('b-col',{attrs:{"md":"6","sm":"12","offset-md":"3"}},[_c('login-form')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }